export interface Icon {
    name: string;
    slug: string;
    title: string;
    link: string | undefined;
    icon: string;
    iconDarkMode: string | undefined;
    isInternalApp: boolean;
}

export type InteractionType = 'installed' | 'suggested';

export interface GetAppsResponse {
    type: InteractionType;
    list: Icon[];
}

export interface AppListItem {
    id: number;
    slug: string;
    title: string;
    summary: string;
    author: string;
    logo: string;
    logoDarkmode?: string;
    categories: AppCategory[];
    isAvailable: boolean;
    isInstalled: boolean;
    isSingleInstallApp: boolean;
    isPopular: boolean;
    isBeta: boolean;
}

export interface AppCategory {
    id: number;
    name: string;
}

export type AppModalInfo = {
    definition: AppDetail;
    suggestedApps: SuggestedApp[];
};

export type AppDetail = {
    id: number;
    author: string;
    slug: string;
    title: string;
    summary: string;
    url: string | undefined;
    docsUrl: string;
    categories: AppCategory[];
    logo: string;
    logoDarkmode: string | undefined;
    about: string;
    keyFeatures: string;
    mediaContent: string;
    isAvailable: boolean;
    isInstalled: boolean;
    isSingleInstallApp: boolean;
    privacyPolicyLink: string;
    termsOfServiceLink: string;
    isInternalApp: boolean;
    isBeta: boolean;
};

export type SuggestedApp = {
    id: number;
    slug: string;
    name: string;
    title: string;
    summary: string;
    author: string;
    icon: string;
    iconDarkMode?: string;
    isSingleInstallApp: boolean;
    isAvailable: boolean;
    isInstalled: boolean;
    isBeta: boolean;
};

export interface AppRequest {
    description: string;
    useCases: string | undefined;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AppResponse {}

export interface AppRequestAvailability {
    available: boolean;
}

export interface AppSettings {
    hooks?: AppHook[];
    params: AppParam[];
    messages: AppCustomMessage;
}

export interface AppCustomMessage {
    noHookSelection: {
        title: string;
        content: string;
    };
}

export interface AppHook {
    type: string;
    title: string;
}

export interface AppParam {
    name: string;
    type: string;
    title: string;
    default: string | number;
    required: boolean;
    placeholder: string;
    tooltip?: string;
    options?: AppOption[];
    disabled?: boolean;
}

export interface AppHookRequest {
    [key: string]: boolean;
}

export interface AppListRequest {
    [key: string]: string | number | AppOption;
}

export interface AppConfigurationRequest {
    hooks: AppHookRequest;
    params: AppListRequest;
    host?: string;
    token?: string;
}

export enum AppAuthorizationType {
    apiToken = 'apiToken',
    oAuth = 'OAuth',
}

export interface AppAuthorizationConfiguration {
    type: AppAuthorizationType;
}

export type AppAuthorizationConfigurationRequest = {
    type: AppAuthorizationType;
} & Record<string, string>;

export interface AppAuthorizationConfigurationResponse {
    type: AppAuthorizationType;
    token: string;
    authenticationUrl: string | null;
}

export interface AppOption {
    value: number;
    label: string;
    group: string;
}

export interface EnvResponse {
    host: string;
}
